import Link from "next/link";
import React from "react";

const Wallet = ({user}) => {
  return (
    <li className="access-icon">
      <Link
        href="/wallet"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "3px",
          padding: "2px 7px",
          backgroundColor: "#f8f9fa",
          borderRadius: "20px",
          textDecoration: "none",
          color: "#000",
          fontWeight: "600",
          fontSize: "14px",
          transition: "all 0.3s ease",
          border: "1px solid #e0e0e0",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#fff";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#f8f9fa";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <span style={{ fontSize: "18px" }}>💵</span>
        <span
          style={{
            color: "#d4a017",
            fontWeight: "700",
            fontSize: "15px",
          }}
        >
          ₹{user?.points || 0}
        </span>
      </Link>
    </li>
  );
};

export default Wallet;
